import intl from 'react-intl-universal';
import { uuid } from '@/utils';
import { parseYuan2Fen, parseFen2Yuan, parse2Number } from '@/utils/number';
import invoiceService from '@/api/invoice';
import { MainState } from '@/redux/reducers/bill/invoice';
import { OrderTypeEnum } from './constant';

// 获取汇总开票订单信息 入参
export type IOders = Array<{ orderNo: string; orderType: string }>;

// 获取汇总开票订单信息
export const getInvoicesSummary: (orders: IOders) => Promise<MainState> = async (
  orders: IOders,
) => {
  const res = await invoiceService.getSummaryInvoice({ orders });
  const { categories, orders: orderList } = res?.data;

  const newOrderList = orderList.map((item: any) => ({
    ...item,
    invoiceAmount: parseFen2Yuan(item.invoiceAmount),
  }));

  return {
    categories,
    orderList: newOrderList,
    invoices: [
      {
        id: uuid(),
        amount: null,
        invoiceCode: '',
        invoiceNo: '',
        invoiceType: null,
      },
    ],
    remark: '',
  };
};
// 获取发票操作详情
export const getInvoicesSummaryDetail: (logId: any) => Promise<MainState> = async (logId: any) => {
  const res = await invoiceService.getInvoicesDetail({ logId });
  const { categories, orders: orderList, invoices, remark } = res?.data;

  const newOrderList = orderList.map((item: any) => ({
    ...item,
    invoiceAmount: parse2Number(parseFen2Yuan(item.invoiceAmount)),
  }));

  return {
    categories,
    orderList: newOrderList,
    invoices,
    remark,
  };
};

// 获取房费明细
export const getRoomIncomeDetail: (orders: IOders) => Promise<any> = async (orders: IOders) => {
  const res = await invoiceService.getRoomIncomeDetail({ orders });
  const { items: dataSource, consumeAmt, invoiceAmt, occDuration } = res?.data;

  return {
    dataSource,
    subtotal: {
      invoiceAmt,
      amount: consumeAmt,
      number: occDuration,
    },
  };
};

// 获取房费明细
export const getGoodsDetail: (orders: IOders) => Promise<any> = async (orders: IOders) => {
  const res = await invoiceService.getGoodsDetail({ orders });
  const { items: dataSource, amount, count } = res?.data;

  return {
    dataSource,
    subtotal: {
      number: count,
      amount,
    },
  };
};

// 查询订单下的发票信息
export const getOrderInvoices: (orderNo: string, orderType: OrderTypeEnum) => Promise<any> = async (
  orderNo: string,
  orderType: OrderTypeEnum,
) => {
  const res = await invoiceService.getOrderInvoices({ orderNo, orderType });
  const { invoiceLogs: invoices = [], moreInvoiceFlag } = res?.data;

  return {
    invoices,
    moreInvoiceFlag,
  };
};

// 提交发票的数据校验
export const checkSubmitInvoiceData = (state: any) => {
  const { invoices, orderList } = state;
  let access = true;
  let msg = '';
  let duration = 3;

  let totalInvoiceAmount = 0; // 本次开票金额汇总
  let totalAmount = 0; // 发票金额汇总

  // 必填校验
  // 1. 校验发票信息
  invoices.forEach((item) => {
    if (!item.amount || Number(item.amount) <= 0) {
      access = false;
      msg = intl.get('bill_invoice_modal_help_invoice_amount_limit');
    }
    if (!item.invoiceNo) {
      access = false;
      msg = intl.get('bill_invoice_modal_alert_info_one');
    }
    if (!item.invoiceType) {
      access = false;
      msg = intl.get('bill_invoice_modal_alert_info_two');
    }
    totalAmount += Number(item.amount);
  });
  // 2.校验订单列表的本次开票金额
  orderList.forEach((item) => {
    if (!item.invoiceAmount || Number(item.invoiceAmount) <= 0) {
      access = false;
      msg = intl.get('bill_invoice_modal_alert_info_three');
    }
    totalInvoiceAmount += Number(item.invoiceAmount);
  });

  // 校验 发票金额汇总 是否等于 本次开票金额汇总
  if (access && totalInvoiceAmount !== totalAmount) {
    access = false;
    msg = intl.get('bill_invoice_modal_alert_info_four');
    duration = 5;
  }
  // 如果不等于，toast 5s 提示：请确认本次开票金额汇总是否等于发票金额汇总
  return { access, msg, duration };
  // 等于 次确认弹窗提醒以下文案“开票后，房间订单不可再操作反结账”
};

// 提交发票信息数据
export const submitInvoiceData = async (state: any) => {
  // 处理数据 金额：string 转成 number 元转分 去除invoices中多余的id
  const { invoices, orderList, remark } = state;
  const newInvoices = invoices.map((item: any) => {
    const { id, ...rest } = item;
    return {
      ...rest,
      amount: Number(parseYuan2Fen(item.amount)),
    };
  });
  const newOrderList = orderList.map((item: any) => ({
    ...item,
    invoiceAmount: Number(parseYuan2Fen(item.invoiceAmount)),
  }));
  const params = {
    invoices: newInvoices,
    orders: newOrderList,
    remark,
  };

  try {
    const { code } = await invoiceService.submitInvoices(params);
    return { success: code === 0 };
  } catch (error) {
    return { success: false };
  }
};

// 获取房费明细
export const getInvoicesTypeList: () => Promise<any> = async () => {
  const res = await invoiceService.getInvoicesTypeList({});
  const optionsMap = {};
  const options = (res?.data || []).map((item) => {
    optionsMap[item.code] = item.name;
    return {
      label: item.name,
      value: item.code,
    };
  });

  return {
    options,
    optionsMap,
  };
};
